import { LegacyRef, ReactNode } from 'react';
import { Easing, View as RNView, ViewStyle } from 'react-native';
import { View } from '@shared/components/View';
import { MBAnimation } from '@shared/components/animation';
import { MBIconV2 } from '@shared/components/image';
import { MBTouchableOpacity } from '@shared/components/touchable';
import { MBTextBody1 } from '@shared/components/typography';
import { Colors, grid } from '@shared/styles';

interface NativeDropdownButtonProps {
  containerRef?: LegacyRef<MBTouchableOpacity>;
  onPress: VoidFunction;
  disabled?: boolean;
  children: ReactNode;
  style?: ViewStyle;
}
export function NativeDropdownButton({
  containerRef,
  onPress,
  disabled,
  children,
  style = {},
}: NativeDropdownButtonProps) {
  return (
    <RNView style={{ flexGrow: 1, flexShrink: 0, marginLeft: grid(1), ...style }}>
      <MBTouchableOpacity
        ref={containerRef}
        onPress={onPress}
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          borderRadius: grid(1),
          height: 43,
          paddingHorizontal: grid(2),
          backgroundColor: Colors.v2.backgroundGrayLight,
        }}
      >
        <MBTextBody1 numberOfLines={1} style={{ maxWidth: '85%' }}>
          {children}
        </MBTextBody1>
        <View marginLeft={2}>
          <MBAnimation
            duration={200}
            easing={Easing.inOut(Easing.quad)}
            disabled={disabled}
            rotate={{ from: '0deg', to: '-180deg' }}
          >
            <MBIconV2 color={Colors.v2.purple} name="arrow-point-down-heavy" size={grid(1.25)} />
          </MBAnimation>
        </View>
      </MBTouchableOpacity>
    </RNView>
  );
}
